var uiCursorPagination = {
	caption: "Paginazione a cursore",
	first: "Prima pagina",
	previous: "Pagina precedente",
	next: "Prossima pagina"
};
var it = {
	uiCursorPagination: uiCursorPagination
};

export { it as default, uiCursorPagination };
